import { http, HttpResponse } from 'msw'

import { allCategories } from 'app/mocks/data/users/categories'

import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

import { CategoriesRequest } from 'app/types/catalogue/category'

export const getAllCategories = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.managers.categories.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allCategories.length > limit ? offset + limit : allCategories.length

        const results = allCategories.slice(offset, limitArray)

        const next =
            offset + results.length < allCategories.length ? 'again' : undefined

        return HttpResponse.json<CategoriesRequest>({
            next,
            results,
        })
    },
)
